import React from "react"
import Dimension from "models/Dimension"
import AuthContext from 'store/AuthContext';
import {Markdown} from 'components/Markdown';

const DimensionInfo: React.FC<{dimension: Dimension}> = (props) => {
    const authCtx = React.useContext(AuthContext)

    return (
        <Markdown url={authCtx.makeFileUrl(props.dimension.id, 'info.md')} noCache={true}/>
    );
};

export default DimensionInfo;
